module.exports = __webpack_public_path__ + "static/media/UK.1d6881bc.jpg";